let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("l4q1r"), load("6j8nK")]).then(() => parcelRequire('dfteC'));